import {
  updateWeatherFeatureFormat,
  headerSearchBarFix,
  updateContentMargin,
  updateSocialWidgetPosition,
} from './utils/helpers';
import { setNavItemAttributes, updateMenuButton } from './utils/handleNavigation';

$(document).ready(function () {
  $('.generalmessage').prependTo('header');
  headerSearchBarFix('Search website');
  updateMenuButton();

  $(globalThis).load(function () {
    updateWeatherFeatureFormat();
    setNavItemAttributes();
    updateContentMargin();
    updateSocialWidgetPosition();
  });
});
